import {PatientPriorityStatus} from "doctors-dashboard/http-clients/index";

type PatientStatusClasses = Record<'statusChipPaused' | 'rowPaused', string>;

export const PatientStatusClassNames = (classes: PatientStatusClasses, statusName?: string | null): { chip?: string, row?: string } => {
    if (statusName === PatientPriorityStatus.Paused)
        return {chip: classes.statusChipPaused, row: classes.rowPaused};

    return {};
};
